// extracted by mini-css-extract-plugin
export default {"table":"rbLxNih0Y71ZSz_TYBge"};